// Page-level strings for the Content view (TASK-034). Composing-widget
// strings stay inside their respective widgets — this dictionary covers
// page chrome (title, header CTA, error/empty/loading states).

export const CONTENT_PAGE_STRINGS = {
  pageTitle: "Content",
  loading: "Loading content analytics…",
  errorTitle: "We couldn't load your content analytics",
  errorBodyDefault: "Something went wrong fetching your community data.",
  retry: "Retry",
  noCommunity: {
    title: "No community connected yet",
    body: "Open the bot in Telegram and follow the prompts to add your first community.",
  },
  empty: {
    title: "Collecting your community's first messages…",
    body: "Once we have at least one message in the last 28 days, the heatmap, top posts, and time-slot recommendations will start populating.",
  },
} as const;

export type ContentPageStrings = typeof CONTENT_PAGE_STRINGS;
